import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const DoughnutChart = ({ type, newData, maxValue }) => {
  const colors = {
    Total: "rgba(140, 145, 216, 1)",
    Used: "rgba(249, 133, 133, 1)",
    Balance: "rgba(100, 221, 169, 1)",
    LOP: "rgba(167, 158, 183, 1)",
  };


  return (
    <div className="circular-progress-bar">
      <CircularProgressbar
        key={`${type}-${newData}-${maxValue}`}
        maxValue={Number(maxValue)}
        value={Number(newData)}
        text={`${newData}`}
        strokeWidth={13}
        styles={buildStyles({
          textColor: "rgba(106, 110, 172, 1)",
          pathColor: colors[type],
          trailColor: "rgba(242, 242, 242, 1)",
        })}
      />
    </div>
  );
};

export default DoughnutChart;
